@if (aside()) {
  <ng-container *ngTemplateOutlet="content" />
} @else {
  <div class="row">
    <div class="col-lg-8">
      <ng-container *ngTemplateOutlet="content" />
    </div>
  </div>
}

<ng-template #content>
  <h2 *scText="heading()" class="text-section__heading mb-2"></h2>
  @if (showRichText() && richText(); as richText) {
    <wl-rich-text-wrapper [field]="richText">
      <div class="text-section__richText mb-2"></div>
    </wl-rich-text-wrapper>
  }
  <ng-content select="[call-to-action-button]" />
  <ng-content select="[app-store-buttons]" />
</ng-template>
